// extracted by mini-css-extract-plugin
export var actionButton = "_qi-0";
export var actionMenuContainer = "_qi-i";
export var bubble = "_qi-2";
export var bubbleActionMenu = "_qi-j";
export var bubbleContext = "_qi-6";
export var bubbleItems = "_qi-7";
export var customer = "_qi-3";
export var divider = "_qi-8";
export var fileList = "_qi-9";
export var hiddenComment = "_qi-o";
export var infoAbove = "_qi-a";
export var internal = "_qi-4";
export var lightActionButton = "_qi-1";
export var link = "_qi-b";
export var merchant = "_qi-5";
export var message = "_qi-c";
export var profilePicture = "_qi-e";
export var quillToolbarContainer = "_qi-f";
export var senderDate = "_qi-g";
export var senderDateCustomer = "_qi-h";
export var senderName = "_qi-d";
export var time = "_qi-k";
export var uploadedImage = "_qi-l";
export var username = "_qi-m";
export var xsmall = "_qi-n";